// global function to be defined

window.addFlashAlert = function(level, message, kind = 'flash')
{
	vue.data.alerts.data.push({message: message, level: level, kind: kind});
};

window.cleanFlashAlert = function(kind = 'flash')
{
	if (kind == '*')
	{
		vue.data.alerts.data = [];
		return;
	}

	vue.data.alerts.data.forEach((alert, index) => {
		if (alert.kind == kind)
		{
			Vue.delete(vue.data.alerts.data, index);
		}
	})
};

window.mergeHash = function(a, b)
{
	return {...a, ...b};
};

$.fn.isInViewport = function() {
	let elementTop = $(this).offset().top;
	let elementBottom = elementTop + $(this).outerHeight();

	let viewportTop = $(window).scrollTop();
	let viewportBottom = viewportTop + $(window).height();

	return elementBottom < viewportBottom && elementTop > viewportTop;
};

$.fn.isFullyVisible = function() {
	let elementTop = $(this).offset().top;
	let elementBottom = elementTop + $(this).outerHeight();
	let elementLeft = $(this).offset().left;
	let elementRight = elementLeft + $(this).outerWidth();

	let viewportTop = $(window).scrollTop();
	let viewportBottom = viewportTop + $(window).height();
	let viewportLeft = $(window).scrollLeft();
	let viewportRight = viewportLeft + $(window).width();

	return elementBottom <= viewportBottom && elementTop >= viewportTop && elementLeft >= viewportLeft && elementRight <= viewportRight;
};
